

import Vue from 'vue';
import store from '../store';

import i18n from '../i18n';

import { mdbSelect, mdbBtn, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbNavbar, mdbNavbarBrand, mdbNavbarToggler, mdbNavbarNav, mdbNavItem, mdbDropdown, mdbDropdownToggle, mdbDropdownMenu, mdbDropdownItem, mdbIcon } from 'mdbvue';

export default Vue.extend({
    props: ['showMenu'],
    data: function () {
        return {
            isMenuShown: this.showMenu !== undefined ? this.showMenu : true,
            name: store.state.name,
            isLanguageModalOpen: false,
            currentLanguage: i18n.locale,
            currentLanguageOption: 'en'
        }
    },
    methods: {
        changeLanguage() {
            i18n.locale = this.currentLanguageOption;
            this.currentLanguage = this.currentLanguageOption;
            this.isLanguageModalOpen = false;
        },
        handleLanguageSelect(e) {
            if(e.target.options.selectedIndex > -1) {
                this.currentLanguageOption = e.target.options[e.target.options.selectedIndex].value;
            }
        }
    },
    components: {
        mdbNavbar, 
        mdbNavbarBrand,
        mdbNavbarToggler,
        mdbNavbarNav,
        mdbNavItem,
        mdbDropdown,
        mdbDropdownMenu,
        mdbDropdownToggle,
        mdbDropdownItem,
        mdbIcon,
        mdbModal, 
        mdbModalHeader, 
        mdbModalTitle, 
        mdbModalBody, 
        mdbModalFooter,
        mdbBtn,
        mdbSelect
    },
});
